/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useContext } from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import EnhancedTable from "components/common_components/Tables/EnhancedTable";
import Button from "components/common_components/Button";
import Page from "components/common_components/Page/Page";
import useStyles from "./useStyles";
import { useDispatch } from "react-redux";
import { notifyError, notifyInfo } from "redux/actions/Notifications";
import LoadingPage from "components/common_components/LoadingPage";
import SigninSheetContext from "./SigninSheetContext";
import Header from "components/common_components/Header";
import Icon from "components/common_components/Icon";

const headCells = [
    { index: 1, id: "fullName", disablePadding: false, label: "Full Name" },
    { index: 2, id: "assigneeName", orderBy: "assigneeUser.name", disablePadding: true, label: "Assignee" },
    { index: 3, id: "caseFileNo", disablePadding: true, label: "Case" },
    { index: 4, id: "appointmentTimeString", orderBy: "appointmentTime", disablePadding: true, label: "Appt. Time" },
    { index: 5, id: "createdByName", orderBy: "stampCreationUser.name", disablePadding: true, label: "Created by" },
    { index: 6, id: "stampCreationDatetimeString", orderBy: "stampCreationDatetime", disablePadding: true, label: "Time" },
];

function List({ history }) {
    const classes = useStyles();
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(false);
    const [data, setData] = useState([]);
    const [pageableData, setPageableData] = useState(undefined);
    const defaultRequestData = {
        filter: {},
        orderBy: "firstName",
        orderDirection: "asc",
        pageNumber: 0,
        pageSize: 5,
    };

    const SigninSheet = useContext(SigninSheetContext);

    function getSigninSheets(requestData = defaultRequestData, showLoader = true) {
        if (showLoader) {
            setIsLoading(true);
        }
        SigninSheet.getList({
            onSuccess: (data, pageableData) => {
                setData(data);
                setPageableData(pageableData);
                setIsLoading(false);
            },
            onInfo: (info, pageableData) => {
                dispatch(notifyInfo(info));
                setPageableData(pageableData);
                setIsLoading(false);
            },
            onError: (error) => {
                dispatch(notifyError(error));
                setIsLoading(false);
            },
            data: requestData,
        });
    }

    useEffect(() => {
        getSigninSheets();

        return () => {
            setData([]);
        };
    }, []);

    function onRowClickHandler(item) {
        history.push(`/check-in/${item.id}`);
    }

    function onDeleteSuccess() {
        dispatch(notifyInfo("Removed successfully!"));
        getSigninSheets();
    }

    function onDeleteError(error) {
        dispatch(notifyError(error.message));
    }

    function onDeleteHandler(selectedItems) {
        SigninSheet.deleteAll({
            ids: selectedItems,
            onSuccess: onDeleteSuccess,
            onError: onDeleteError,
        });
    }

    function filterBuilder(filterValue) {
        return filterValue
            ? {
                  firstName: filterValue,
                  middleName: filterValue,
                  lastName: filterValue,
                  caseFileNo: filterValue,
              }
            : {};
    }

    return (
        <Page className={classes.root}>
            {isLoading ? (
                <LoadingPage />
            ) : (
                <>
                    <Header title="Check-in">
                        <Button primary onClick={() => history.push("/check-in/add")}>
                            <Icon name="add" size="md" color="white" />
                            <span>Add</span>
                        </Button>
                    </Header>
                    <div className="layout">
                        <EnhancedTable
                            headCells={headCells}
                            data={data}
                            title="Check-in"
                            dense={false}
                            defaultOrder={{ order: "asc", orderBy: "firstName" }}
                            keyColumnName="id"
                            selectable
                            onRowClick={onRowClickHandler}
                            onDelete={onDeleteHandler}
                            onRequestData={getSigninSheets}
                            filterBuilder={filterBuilder}
                            pageableData={pageableData}
                        />
                    </div>
                </>
            )}
        </Page>
    );
}

List.propTypes = {
    history: PropTypes.shape({
        replace: PropTypes.func,
        location: PropTypes.shape({
            pathname: PropTypes.string,
        }),
    }).isRequired,
};

export default withRouter(List);
